import { configureStore } from "@reduxjs/toolkit";
import slice from "./reducers/index";
import projectSlice from "./reducers/projectReducers";
import logger from "redux-logger";
import uiSlice from "./reducers/uiState";
import usersSlice from "./reducers/users";
import ProfileSlice from "./reducers/profile";
import ImageSlice from "./reducers/image";
import PdfSlice from "./reducers/pdf";
import machineSlice from "./reducers/machineReducers";
import inventorySlice from "./reducers/inventorySlice";
import thresholdItemSlice from "./reducers/thresholdItems";
import inventoryHandoverRequestSlice from "./reducers/inventoryHandover";
import workInProgressPilesData from "./reducers/dashboardReducers";
import billSlice from "./reducers/billReducer";
import pilesSlice from "./reducers/pilesReducers";
import reportSlice from "./reducers/reportReducer";

export const store = configureStore({
  reducer: {
    UI: slice.reducer,
    PROJECT: projectSlice.reducer,
    REPORT: reportSlice.reducer,
    SPECIFICPROJECT: uiSlice.reducer,
    USERS: usersSlice.reducer,
    PROFILE: ProfileSlice.reducer,
    IMAGE: ImageSlice.reducer,
    PDF: PdfSlice.reducer,
    MACHINE: machineSlice.reducer,
    INVENTORY: inventorySlice.reducer,
    THRESHOLD_VALUES: thresholdItemSlice.reducer,
    INVENTORY_HANDOVER: inventoryHandoverRequestSlice.reducer,
    DASHBOARD: workInProgressPilesData.reducer,
    BILLS: billSlice.reducer,
    PILES: pilesSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(logger),
  // }),
});

export type AppDispatch = typeof store.dispatch;
